import { Bot, Maximize2, Plus, Send, Sparkles, X } from "lucide-react";
import { FormEvent, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Md, SUGGEST, useAiChat } from "../lib/aiChat";
import { cn } from "./ui";

export function AiChatWidget() {
  const [open, setOpen] = useState(false);
  const { msgs, busy, ask, fresh } = useAiChat();
  const [q, setQ] = useState("");
  const bottom = useRef<HTMLDivElement>(null);
  const nav = useNavigate();
  const loc = useLocation();
  useEffect(() => { bottom.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);
  if (loc.pathname === "/asisten-ai") return null;
  const send = (t: string) => { setQ(""); ask(t); };
  const submit = (e: FormEvent) => { e.preventDefault(); send(q); };

  return (
    <>
      {!open && (
        <button type="button" onClick={() => setOpen(true)} data-testid="ai-widget-open" title="Asisten AI"
          className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-xl shadow-primary/30 grid place-items-center transition-transform hover:scale-105 active:scale-95">
          <Bot className="h-6 w-6" />
        </button>
      )}
      {open && (
        <div data-testid="ai-widget" className="fixed bottom-5 right-5 z-40 w-[min(400px,calc(100vw-2.5rem))] h-[min(560px,calc(100vh-5rem))] card-surface shadow-2xl flex flex-col overflow-hidden border">
          <div className="flex items-center gap-2 px-3 py-2.5 border-b bg-[hsl(var(--sidebar))] text-white">
            <Bot className="h-5 w-5" /><p className="font-semibold text-sm flex-1">Asisten AI</p>
            <button type="button" onClick={fresh} title="Percakapan baru" data-testid="ai-widget-new" className="p-1.5 rounded hover:bg-white/10"><Plus className="h-4 w-4" /></button>
            <button type="button" onClick={() => { setOpen(false); nav("/asisten-ai"); }} title="Buka halaman penuh" data-testid="ai-widget-expand" className="p-1.5 rounded hover:bg-white/10"><Maximize2 className="h-4 w-4" /></button>
            <button type="button" onClick={() => setOpen(false)} title="Tutup" data-testid="ai-widget-close" className="p-1.5 rounded hover:bg-white/10"><X className="h-4 w-4" /></button>
          </div>
          <div className="flex-1 overflow-y-auto p-3 space-y-3" data-testid="ai-widget-messages">
            {msgs.length === 0 && (
              <div className="text-center pt-6">
                <p className="text-sm font-semibold">Tanya data koperasi</p>
                <div className="mt-3 flex flex-wrap justify-center gap-1.5">{SUGGEST.slice(0, 3).map((s) => <button key={s} onClick={() => send(s)} data-testid="ai-widget-suggest" className="text-[11px] rounded-full border px-2.5 py-1 hover:bg-muted inline-flex items-center gap-1"><Sparkles className="h-3 w-3" /> {s}</button>)}</div>
              </div>
            )}
            {msgs.map((m, i) => (
              <div key={i} className={cn("flex", m.role === "user" ? "justify-end" : "justify-start")} data-testid={`ai-widget-msg-${m.role}`}>
                <div className={cn("max-w-[90%] rounded-2xl px-3 py-2", m.role === "user" ? "bg-primary text-primary-foreground text-sm" : "bg-muted")}>
                  {m.role === "user" ? m.content : m.content ? <Md text={m.content} /> : <span className="text-xs text-muted-foreground animate-pulse">Menganalisis data…</span>}
                </div>
              </div>
            ))}
            <div ref={bottom} />
          </div>
          <form onSubmit={submit} className="border-t p-2 flex gap-2">
            <input className="yt-input flex-1 h-9 text-sm" placeholder="Tulis pertanyaan…" value={q} onChange={(e) => setQ(e.target.value)} disabled={busy} data-testid="ai-widget-input" />
            <button type="submit" disabled={busy || !q.trim()} data-testid="ai-widget-send" className="h-9 w-9 rounded-md bg-primary text-primary-foreground grid place-items-center disabled:opacity-50"><Send className="h-4 w-4" /></button>
          </form>
        </div>
      )}
    </>
  );
}
